module.exports = __webpack_public_path__ + "static/media/food-fruit-gastronomy-svgrepo-com.806399d1.svg";